import { history } from '~/services/history';

/**
 * Navigates to specified path while maintaining path of current location.
 * Attention! Saved path will disappear on next push
 *
 * @see getBackStepPath
 * @param path - path for location push
 */
export const historyPushWithSaveBackPath = (path: string): void => {
  history.push(path, { backStepPath: history.location.pathname });
};
